export const LEFT_SIDE_BAR_SELECTED = "LEFT_SIDE_BAR_SELECTED";
export const SET_LAYOUT_FULL_SCREEN = "SET_LAYOUT_FULL_SCREEN";

const initialState = {
    selectedComponent: null,
    fullScreen: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LEFT_SIDE_BAR_SELECTED:
            return {
                ...state,
                selectedComponent: action.payload,
            };
        case SET_LAYOUT_FULL_SCREEN:
            return {
                ...state,
                fullScreen: action.payload,
            };
        default:
            return state;
    }
}

const storeName = "selectedComponent";

const storeMapping = {[storeName]: reducer};

export const selectedComponentSelector = (state) => state[storeName].selectedComponent;
export const fullScreenLayoutSelector = (state) => state[storeName].fullScreen;

export default storeMapping;
